import * as React from 'react';

import { TrackedLink } from '../TrackedLink/TrackedLink';

export const isOutboundLink = (href: string | undefined) => {
  if (!href) return false;

  /* Ensures all hrefs have a hostname.
   * Necessary for internal URIs like '/clover-station'
   */
  const anchor = document.createElement('a');
  anchor.href = href;

  const isHrefOutBoundLink = href.endsWith('#target=_blank');
  if (isHrefOutBoundLink) return true;

  const isInternalLink =
    anchor.hostname === location.hostname || anchor.hostname.includes('clover.com') || href.startsWith('~');

  return !isInternalLink;
};

const removeTargetBlankFragmentFromHref = (href: string) => href.replace('#target=_blank', '');

export const LinkRenderer = React.forwardRef<HTMLAnchorElement, React.AllHTMLAttributes<HTMLAnchorElement>>(
  ({ href, ...props }, ref) => {
    if (!href) return null;

    const outboundLink = isOutboundLink(href);
    const finalHref = removeTargetBlankFragmentFromHref(href);

    return (
      <TrackedLink
        ref={ref}
        target={(outboundLink && '_blank') || undefined}
        rel={(outboundLink && 'noopener') || undefined}
        {...{ href: finalHref, ...props }}
      />
    );
  },
);
